/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _fn } from '@mairistem/administres-utils';
import { Liste } from '@mairistem/liste';

import type { Diplome } from '@/types';

import DiplomeListeTable from './DiplomeListeTable';

interface Props {
  /** Nombre de lignes */
  count?: number;
  /** État du chargement */
  loading?: boolean;
  /** Callback appelé lors du chargement de la liste */
  onLoad?: () => void;
  /** Callback appelé lors d'une saisie dans la barre de recherche */
  onSearch?: (value: string) => Promise<void>;
  /** Callback appelé lors d'un clique sur les filtres */
  onSort?: () => void;
  /** Nombre d'éléments définis par page */
  perPage?: number;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: Diplome) => void;
  /** Données de la liste */
  diplomes?: Diplome[];
  /** Callback appelé lors de la sauvegarde (liste en saisie) */
  onSave?: (qualification: Diplome) => void;
  /** Diplôme sélectionné */
  selectedDiplome?: Diplome;
  /** Callback appelé lors du reset des items */
  resetSelectedItems?: (qualification: Diplome) => void;
}

const DiplomeListe = (props: Props) => {
  const {
    count = 0,
    perPage = 50,
    diplomes = [],
    selectedDiplome = {},
    loading = false,
    onLoad = null,
    onSearch = null,
    onSort = null,
    onSelect = null,
    onSave = null,
    resetSelectedItems = null,
    ...rest
  } = props;

  const handleSelect = React.useCallback(
    (qualification: Diplome, qualifications: Diplome[]) => {
      _fn(onSelect, !_.isEmpty(qualifications) ? qualification : {});
    },
    [onSelect],
  );

  return (
    <Liste title="" searchable onSearch={onSearch} loading={loading} {...rest}>
      <Liste.Content>
        <DiplomeListeTable
          items={diplomes}
          count={count}
          loading={loading}
          onLoad={onLoad}
          onSelect={handleSelect}
          perPage={perPage}
          onSort={onSort}
          onSave={onSave}
          selectedDiplome={selectedDiplome}
          resetSelectedItems={resetSelectedItems}
        />
      </Liste.Content>
    </Liste>
  );
};

export default DiplomeListe;
